module.exports = __webpack_public_path__ + "img/hand-stop.c1b9ca0a.svg";